const browserEnv = (typeof window !== 'undefined' && (window as any).__env) ? (window as any).__env : {};

export const environment = {
    production: browserEnv.production !== undefined ? (browserEnv.production === true || browserEnv.production === 'true') : false,
    hmr: false,
    apiUrl: browserEnv.apiUrl || 'https://api.vietstem.com'
};
